// extracted by mini-css-extract-plugin
export default {"AppInput":"AppInput_AppInput__ucMeT","AppInput__wrapper":"AppInput_AppInput__wrapper__cRtg+","AppInput__currency":"AppInput_AppInput__currency__ln9uP"};